export const TileBorderCode = {
    /**
     * The tile is completely surrounded by closed tiles.
     * @constant
     * @type {number}
     */
    NO_OPEN_BORDERS: 0,
    /**
     * @constant
     * @type {number}
     */
    NORTH_BORDER_OPEN: 1, // PRIMARY
    /**
     * @constant
     * @type {number}
     */
    SOUTH_BORDER_OPEN: 2, // PRIMARY
    /**
     * @constant
     * @type {number}
     */
    NORTH_SOUTH_OPEN: 3,
    /**
     * @constant
     * @type {number}
     */
    WEST_BORDER_OPEN: 4, // PRIMARY
    /**
     * @constant
     * @type {number}
     */
    NORTH_WEST_OPEN: 5,
    /**
     * @constant
     * @type {number}
     */
    SOUTH_WEST_OPEN: 6,
    /**
     * @constant
     * @type {number}
     */
    NORTH_SOUTH_WEST_OPEN: 7,
    /**
     * @constant
     * @type {number}
     */
    EAST_BORDER_OPEN: 8, // PRIMARY
    /**
     * @constant
     * @type {number}
     */
    NORTH_EAST_OPEN: 9,
    /**
     * @constant
     * @type {number}
     */
    SOUTH_EAST_OPEN: 10,
    /**
     * @constant
     * @type {number}
     */
    NORTH_SOUTH_EAST_OPEN: 11,
    /**
     * @constant
     * @type {number}
     */
    WEST_EAST_OPEN: 12,
    /**
     * @constant
     * @type {number}
     */
    NORTH_WEST_EAST: 13,
    /**
     * @constant
     * @type {number}
     */
    SOUTH_WEST_EAST: 14,
    /**
     * The tile is completely surrounded by open tiles.
     * @constant
     * @type {number}
     */
    ALL_BORDERS_OPEN: 15
};
